import { render, staticRenderFns } from "./WorkOrderTemplate.vue?vue&type=template&id=2063f93e&scoped=true&"
import script from "./WorkOrderTemplate.vue?vue&type=script&lang=js&"
export * from "./WorkOrderTemplate.vue?vue&type=script&lang=js&"
import style0 from "./WorkOrderTemplate.vue?vue&type=style&index=0&id=2063f93e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2063f93e",
  null
  
)

export default component.exports